import { Component, OnInit, EventEmitter, Inject, Input } from '@angular/core';
import { IModule } from 'projects/web-user-profile/src/app/models/templates/modules/i-module';
import { ReportProfileBaseModel, UserModel, BaseProviderInstanceResourceModel, MicrosoftOfficeReportProfileModel, SharePointReportProfile, AlertInvalidStateFeaturedModel, ReportProfileResourceBase } from '@i2a/web-api-client';
import { RegisterMyProfileComponent } from 'projects/web-user-profile/src/app/decorators/my-profile-component.decorator';
import { ProfileBaseClassComponent } from '../../../../shared/profile-base-class-component';
import { ToastrService } from 'ngx-toastr';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { SharePointNodataConfiguration } from 'projects/web-user-profile/src/app/models/templates/modules/configuration/share-point-nodata-configuration';
import { TemplateConstants } from 'projects/web-user-profile/src/app/models/templates/template-constants';
import { BaseTemplate } from 'projects/web-user-profile/src/app/models/templates/base-template';
import { SharePointDelegate } from 'projects/web-user-profile/src/app/models/providers/microsoft/share-point/share-point-delegate';

@RegisterMyProfileComponent(TemplateConstants.MODULE_SHAREPOINT_NODATA)
@Component({
  selector: 'i2a-share-point-nodata-module',
  templateUrl: './share-point-nodata-module.component.html',
  styleUrls: ['./share-point-nodata-module.component.scss']
})
export class SharePointNodataModuleComponent extends ProfileBaseClassComponent<SharePointNodataConfiguration,SharePointReportProfile> implements OnInit, IModule<SharePointNodataConfiguration> {
  private resource: BaseProviderInstanceResourceModel;
  
  @Input() 
  public delegatesWithAccessAndPermissions: SharePointDelegate[];
  
  constructor(
    toastr: ToastrService,
    @Inject(I18NEXT_SERVICE) i18Next: ITranslationService) {
    super(toastr, i18Next, null);
  }

  ngOnInit() {
  }

  initialize(user: UserModel, profile: ReportProfileBaseModel, configuration: SharePointNodataConfiguration, alerts: AlertInvalidStateFeaturedModel[], resource: BaseProviderInstanceResourceModel, resourceTemplate?: BaseTemplate): void {
    this.baseInitialize(user, profile, configuration, alerts);
    this.resource = resource;
    this.resourceProfile = (<MicrosoftOfficeReportProfileModel>profile).sharePointProfiles.find(r => r.providerInstanceResource.providerInstanceResourceId == resource.providerInstanceResourceId);
  }

  alertSent(event): void {
    this.onAlertSent.emit(event);
  }

}
